"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const UriHelper_1 = __importDefault(require("../utilities/UriHelper"));
const rxjs_1 = require("rxjs");
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "GET";
    HttpMethod["Post"] = "POST";
    HttpMethod["Put"] = "PUT";
    HttpMethod["Patch"] = "PATCH";
    HttpMethod["Delete"] = "DELETE";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
function asyncScheduled(f) { return rxjs_1.scheduled(f, rxjs_1.asyncScheduler); }
exports.asyncScheduled = asyncScheduled;
class PeakDataClient {
    constructor(baseUri, token) {
        this.baseUri = baseUri;
        this.token = token;
    }
    resolveUri(params) {
        return UriHelper_1.default.resolve(Object.assign({ base: this.baseUri }, params));
    }
    requestAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            //console.log("Params", params);
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                let authenticate = params.authenticate == undefined ? true : params.authenticate;
                axios_1.default.request({
                    url: this.resolveUri(params),
                    data: params.body,
                    method: params.method,
                    headers: authenticate ? { "Token": this.token } : {}
                }).then(response => resolve(response.data)).catch(reject);
            }));
        });
    }
    request(params) {
        return asyncScheduled(this.requestAsync(params));
    }
    getAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requestAsync(Object.assign({ method: HttpMethod.Get }, params));
        });
    }
    get(params) {
        return asyncScheduled(this.getAsync(params));
    }
    postAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requestAsync(Object.assign({ method: HttpMethod.Post }, params));
        });
    }
    post(params) {
        return asyncScheduled(this.postAsync(params));
    }
    putAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requestAsync(Object.assign({ method: HttpMethod.Put }, params));
        });
    }
    put(params) {
        return asyncScheduled(this.putAsync(params));
    }
    patchAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requestAsync(Object.assign({ method: HttpMethod.Patch }, params));
        });
    }
    patch(params) {
        return asyncScheduled(this.patchAsync(params));
    }
    deleteAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requestAsync(Object.assign({ method: HttpMethod.Delete }, params));
        });
    }
    delete(params) {
        return asyncScheduled(this.deleteAsync(params));
    }
}
exports.default = PeakDataClient;
